import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./styles/app.scss";
import "./firebase";

import { MachineProvider } from "./contexts/MachineContext";
import { AuthProvider } from "./contexts/AuthContext";
import { DatabaseProvider } from "./contexts/DatabaseContext";
import { StorageProvider } from "./contexts/StorageContext";

import Dashboard from "./pages/Dashboard";
import Header from "./components/Header";
import Editor from "./pages/Editor";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Tutorial from "./pages/Tutorial";
import Loading from "./components/Loading";
import MobileApp from "./MobileApp";

function App() {
	const [mobile, setMobile] = useState(false);
	const [width, setWidth] = useState(window.innerWidth);

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
		setMobile(window.innerWidth <= 500);
	}
	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	return (
		<Router>
			<AuthProvider>
				{mobile ? (
					<MobileApp />
				) : (
					<DatabaseProvider>
						<StorageProvider>
							<Header />
							<div className="app-wrapper">
								<Routes>
									<Route
										path="/"
										exact="true"
										element={<Home />}
									/>
									<Route
										path="/editor/:machineID"
										element={
											<MachineProvider>
												<Editor />
											</MachineProvider>
										}
									/>
									<Route
										path="/editor"
										element={
											<MachineProvider>
												<Editor />
											</MachineProvider>
										}
									/>
									<Route
										path="/dashboard"
										element={<Dashboard />}
									/>
									<Route path="/login" element={<Login />} />
									<Route
										path="/signup"
										element={<Signup />}
									/>
									<Route path="/acerca"></Route>
									<Route
										path="/tutorial"
										element={<Tutorial />}
									></Route>
									<Route
										path="/loading"
										element={
											<Loading
												description={
													"Cargando contenido"
												}
											/>
										}
									></Route>
								</Routes>
							</div>
						</StorageProvider>
					</DatabaseProvider>
				)}
			</AuthProvider>
		</Router>
	);
}

export default App;
